import { render, staticRenderFns } from "./the-header-cart.vue?vue&type=template&id=5fc50931&"
import script from "./the-header-cart.vue?vue&type=script&lang=js&"
export * from "./the-header-cart.vue?vue&type=script&lang=js&"
import style0 from "./the-header-cart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports